import { types as t } from 'mobx-state-tree';
import { CorrectAnswer } from './correct-answer.store';

export const BlankCorrectAnswer = CorrectAnswer.named('BlankCorrectAnswer').props({
  blankId: t.maybeNull<any>(t.string),
});

